<div class="hotelDetailsGall_template">
  <div class="dialoag_body_">
      <div class="header_dialog">
          <div class="headerContent">
            <h3 mat-dialog-title class="dialog-title">amenities</h3>
          </div>
          <button mat-mini-fab color="primary" class="closeButton" mat-dialog-close><mat-icon>close</mat-icon></button>
      </div>
      <div class="body_dialog">
        <div class="wrapper">
          <div class="innerWrapper">
            <ul>
              <ng-container *ngFor="let item of list">
                <li>
                    <mat-icon *ngIf="item.icon == null">check_circle</mat-icon>
                    <mat-icon *ngIf="item.icon !== null"><img [src]="item.icon" alt="" class="img-fluid"></mat-icon>
                  {{item.name}}
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
  </div>
</div>
